<template>
  <div>
    <ol class="tabel-dinamis-progress-stepper-selection">
      <li
        class="tabel-dinamis-progress-stepper-selection-item"
        id="tabel-dinamis-progress-stepper-subject"
        :style="{
          '--stepColor': categoryStepColor,
        }"
      >
        <category-selection
          :projectName="projectName"
          :originalOptionsCategory.sync="optionsCategory"
          :originalSelectedCategory.sync="selectedCategory"
          :originalIsCategoryNextClicked.sync="isCategoryNextClicked"
          :isLoadingAnOptions.sync="isLoadingAnOptions"
          :isClearAllLocalStorage.sync="isClearAllLocalStorage"
          :isEditSelectedData="isEditSelectedData2"
          :idxSelectedData="idxSelectedData"
        />
      </li>

      <li
        class="tabel-dinamis-progress-stepper-selection-item"
        id="tabel-dinamis-progress-stepper-dataset"
        :style="{
          '--stepColor': datasetStepColor,
        }"
      >
        <dataset-selection
          :projectName="projectName"
          :originalOptionsDataset.sync="optionsDataset"
          :originalSelectedDataset.sync="selectedDataset"
          :originalIsDatasetNextClicked.sync="isDatasetNextClicked"
          :subjectName="selectedSubjectName"
          :subjectId="selectedSubjectId"
          :categoryId="selectedCategory"
          :categoryName="selectedCategoryName"
          :originalIsCategoryNextClicked="isCategoryNextClicked"
          :originalIsSubjectNextClicked="isSubjectNextClicked"
          :isLoadingAnOptions.sync="isLoadingAnOptions"
          :isEditSelectedData="isEditSelectedData2"
          :idxSelectedData="idxSelectedData"
        />
      </li>

      <li
        class="tabel-dinamis-progress-stepper-selection-item"
        id="tabel-dinamis-progress-stepper-indicator"
        :style="{
          '--stepColor': indicatorStepColor,
        }"
      >
        <indicator-selection
          :originalOptionsIndicator.sync="optionsIndicator"
          :originalSelectedIndicator.sync="selectedIndicator"
          :originalIsIndicatorNextClicked.sync="isIndicatorNextClicked"
          :datasetName="selectedDatasetName"
          :datasetId="selectedDatasetId"
          :originalIsDatasetNextClicked="isDatasetNextClicked"
          :isLoadingAnOptions.sync="isLoadingAnOptions"
          :isEditSelectedData="isEditSelectedData2"
          :idxSelectedData="idxSelectedData"
          :hasFinishedLoadEditedSelectedData="hasFinishedLoadEditedSelectedData"
        />
      </li>

      <li
        class="tabel-dinamis-progress-stepper-selection-item"
        id="tabel-dinamis-progress-stepper-period"
        :style="{
          '--stepColor': periodStepColor,
        }"
      >
        <period-selection
          :originalOptionsPeriod.sync="optionsPeriod"
          :originalSelectedPeriod.sync="selectedPeriod"
          :originalIsPeriodNextClicked.sync="isPeriodNextClicked"
          :datasetName="selectedDatasetName"
          :datasetId="selectedDatasetId"
          :originalIsIndicatorNextClicked="isIndicatorNextClicked"
          :isLoadingAnOptions.sync="isLoadingAnOptions"
          :isEditSelectedData="isEditSelectedData2"
          :idxSelectedData="idxSelectedData"
          :hasFinishedLoadEditedSelectedData="hasFinishedLoadEditedSelectedData"
        />
      </li>

      <li
        class="tabel-dinamis-progress-stepper-selection-item"
        id="tabel-dinamis-progress-stepper-dimension"
        :style="{
          '--stepColor': dimensionStepColor,
        }"
      >
        <dimension-selection
          :originalOptionsDimension.sync="optionsDimension"
          :originalSelectedDimension.sync="selectedDimension"
          :originalSelectedDistrict.sync="selectedDistrict"
          :originalSelectedProvince.sync="selectedProvince"
          :originalSelectedRegionLevel.sync="selectedRegionLevel"
          :originalSelectedSubdistrict.sync="selectedSubdistrict"
          :originalIsDimensionNextClicked.sync="isDimensionNextClicked"
          :datasetName="selectedDatasetName"
          :datasetId="selectedDatasetId"
          :originalIsPeriodNextClicked="isPeriodNextClicked"
          :isLoadingAnOptions.sync="isLoadingAnOptions"
          :isEditSelectedData="isEditSelectedData2"
          :idxSelectedData="idxSelectedData"
          :hasFinishedLoadEditedSelectedData.sync="
            hasFinishedLoadEditedSelectedData
          "
        />
      </li>
    </ol>

    <flying-menu-selection
      :isLoadingAnOptions="isLoadingAnOptions"
      :isClearAllLocalStorage.sync="isClearAllLocalStorage"
      :isChangeDataCart.sync="isChangeDataCart"
      :isEditSelectedData="isEditSelectedData2"
    />

    <bottom-menu-selection
      :isDimensionNextClicked="isDimensionNextClicked"
      :addDataCartParent="addDataCart"
      :isEditSelectedData="isEditSelectedData"
      :cancelUpdateDataCartParent="cancelUpdateDataCart"
      :updateDataCartParent="updateDataCart"
      :hasFinishedLoadEditedSelectedData="hasFinishedLoadEditedSelectedData"
      :setIsStep2="setIsStep2"
      :checkDisabledStep2="checkDisabledStep2"
      :setIsProcessingNow="setIsProcessingNow"
      :updateTempDataCart="updateParentTempDataCart"
    />

    <data-cart-modal
      :isChangeDataCart.sync="isChangeDataCart"
      :isEditSelectedData.sync="isEditSelectedData2"
      :idxSelectedData.sync="idxSelectedData"
      :setIsStep2="setIsStep2"
      :checkDisabledStep2="checkDisabledStep2"
    />
  </div>
</template>

<!-- javascript section-->
<script>
//import js modules section
import DatasetSelection from "./SelectionStep/DatasetSelection.vue";
import DimensionSelection from "./SelectionStep/DimensionSelection.vue";
import IndicatorSelection from "./SelectionStep/IndicatorSelection.vue";
import PeriodSelection from "./SelectionStep/PeriodSelection.vue";
// import SubjectSelection from "./SelectionStep/SubjectSelection.vue";
import CategorySelection from "./SelectionStep/CategorySelection.vue";
import FlyingMenuSelection from "./SelectionStep/FlyingMenuSelection.vue";
import BottomMenuSelection from "./SelectionStep/BottomMenuSelection.vue";
import DataCartModal from "./SelectionStep/DataCartModal.vue";
import utils from "../../../../utils/TabelDinamisUtils";
import store from "../../../../store/TabelDinamisStoreV3.js";

const idleStepColor = "lightgray",
  ongoingStepColor = "#f8a054",
  finishStepColor = "#56c596";

//local registration for output component
export default {
  name: "SelectionStep",
  data() {
    return {
      optionsDataset: "",
      optionsDimension: "",
      optionsIndicator: "",
      optionsPeriod: "",
      optionsSubject: "",
      optionsCategory: "",
      selectedDataset: null,
      selectedDimension: [],
      selectedIndicator: [],
      selectedPeriod: [],
      selectedSubject: null,
      selectedCategory: null,
      selectedDistrict: null,
      selectedSubdistrict: null,
      selectedProvince: null,
      selectedRegionLevel: "",
      isDatasetNextClicked: false,
      isDimensionNextClicked: false,
      isIndicatorNextClicked: false,
      isLoadingAnOptions: false,
      isPeriodNextClicked: false,
      isSubjectNextClicked: false,
      isCategoryNextClicked: false,
      isClearAllLocalStorage: false,
      isChangeDataCart: false,
      idxSelectedData: -1,
      hasFinishedLoadEditedSelectedData: false,
      isEditSelectedData2: this.isEditSelectedData,
    };
  },
  props: [
    "projectName",
    "setIsStep2",
    "checkDisabledStep2",
    "setIsProcessingNow",
    "isEditSelectedData",
    "refreshKeySelectedDataList",
    "updateRefreshKeySelectedDataList",
    "updateTempDataCart",
  ],
  created() {},
  destroyed() {},
  mounted: function () {
    this.scrollToUpperMost();
    this.setIsProcessingNow(false);
  },
  computed: {
    subjectStepColor: function () {
      return this.computeStepColor(
        this.optionsSubject,
        this.selectedSubject,
        this.isSubjectNextClicked
      );
    },
    categoryStepColor: function () {
      return this.computeStepColor(
        this.optionsCategory,
        this.selectedCategory,
        this.isCategoryNextClicked
      );
    },
    datasetStepColor: function () {
      return this.computeStepColor(
        this.optionsDataset,
        this.selectedDataset,
        this.isDatasetNextClicked
      );
    },
    indicatorStepColor: function () {
      return this.computeStepColor(
        this.optionsIndicator,
        this.selectedIndicator,
        this.isIndicatorNextClicked
      );
    },
    periodStepColor: function () {
      return this.computeStepColor(
        this.optionsPeriod,
        this.selectedPeriod,
        this.isPeriodNextClicked
      );
    },
    dimensionStepColor: function () {
      return this.computeStepColor(
        this.optionsDimension,
        this.selectedDimension,
        this.isDimensionNextClicked
      );
    },
    selectedSubjectName: function () {
      if (this.selectedSubject != null) {
        return this.selectedSubject.name;
      } else {
        return "";
      }
    },
    selectedCategoryName: function () {
      if (this.selectedCategory != null) {
        return this.selectedCategory.category;
      } else {
        return "";
      }
    },
    selectedSubjectId: function () {
      if (this.selectedSubject != null) {
        return this.selectedSubject.id;
      } else {
        return "";
      }
    },
    selectedDatasetName: function () {
      if (this.selectedDataset != null) {
        return this.selectedDataset.name;
      } else {
        return "";
      }
    },
    selectedDatasetId: function () {
      if (this.selectedDataset != null) {
        return this.selectedDataset.id;
      } else {
        return "";
      }
    },
  },
  watch: {
    isEditSelectedData2: {
      handler: function (newVal, oldVal) {
        if (newVal !== oldVal) {
          this.$emit("update:isEditSelectedData", this.isEditSelectedData2);
          this.selectedDistrict = null;
          this.selectedSubdistrict = null;
          this.selectedProvince = null;
          this.selectedRegionLevel = "";
          this.selectedDimension = [];
          this.optionsDimension = "";

          this.selectedPeriod = [];
          this.optionsPeriod = "";

          this.selectedIndicator = [];
          this.optionsIndicator = "";

          this.selectedDataset = null;
          this.optionsDataset = "";

          this.selectedSubject = null;

          setTimeout(
            function () {
              if (newVal) {
                let selectedDataList =
                  store.getSelectedDataListLocalStorageByCurrentUsername();

                this.selectedSubject =
                  selectedDataList[0].items[
                    this.idxSelectedData
                  ].selectedSubject;

                this.isSubjectNextClicked = true;
              }
            }.bind(this),
            250
          );
        }
      },
      immediate: true,
    },
  },
  methods: {
    scrollToUpperMost() {
      utils.scrollToUpperMost();
    },
    computeStepColor(options, selected, isNextClicked) {
      if (options === "") {
        return idleStepColor;
      } else if (options !== "" && !isNextClicked) {
        return ongoingStepColor;
      } else if (options !== "" && selected != null && isNextClicked) {
        return finishStepColor;
      }
    },
    addDataCart() {
      utils.scrollIntoDiv("tabel-dinamis-progress-stepper-subject");

      setTimeout(
        function () {
          let x = store.getSelectedDataListLocalStorageByCurrentUsername();

          let selectedData = this.setSelectedData();

          if (x == null || x.length === 0) {
            store.insertNewSelectedDataListLocalStorageByCurrentUsername(
              selectedData
            );
          } else if (x.length > 0) {
            store.updateNewSelectedDataListLocalStorageByCurrentUsername(
              selectedData
            );
          }

          let rksdl = this.refreshKeySelectedDataList;
          this.updateRefreshKeySelectedDataList(rksdl + 1);

          this.selectedSubject = null;

          this.isChangeDataCart = true;

          this.$bvToast.toast(
            "Jumlah data dalam keranjang : " +
              store.getSelectedDataListLocalStorageByCurrentUsername()[0].items
                .length,
            {
              title: "Berhasil simpan data ke keranjang",
              autoHideDelay: 4000,
              variant: "info",
              "header-class": "font-weight-bolder",
            }
          );

          this.checkDisabledStep2();
        }.bind(this),
        250
      );
    },
    updateDataCart() {
      utils.scrollIntoDiv("tabel-dinamis-progress-stepper-subject");

      setTimeout(
        function () {
          let selectedDimension = this.optionsDimension.map(
            ({ itemsDimension, ...item }) => item // eslint-disable-line no-unused-vars
          );

          selectedDimension.forEach((item, idx) => {
            item.selectedItemDimension = this.selectedDimension[idx];
            if (item.role.toLowerCase() === "region") {
              item.selectedRegionLevel = this.selectedRegionLevel;
              item.selectedProvince = this.selectedProvince;
              item.selectedDistrict = this.selectedDistrict;
              item.selectedSubdistrict = this.selectedSubdistrict;
            }
          });

          let y = {
            selectedSubject: this.selectedSubject,
            selectedDataset: this.selectedDataset,
            selectedIndicator: this.selectedIndicator,
            selectedPeriod: this.selectedPeriod,
            selectedDimension: selectedDimension,
          };

          store.updateNewSelectedDataListLocalStorageByCurrentUsernameAndItemIndex(
            y,
            this.idxSelectedData
          );

          let rksdl = this.refreshKeySelectedDataList;
          this.updateRefreshKeySelectedDataList(rksdl + 1);

          this.selectedSubject = null;

          this.isChangeDataCart = true;

          this.idxSelectedData = -1;
          this.isEditSelectedData2 = false;
          this.hasFinishedLoadEditedSelectedData = false;

          this.$bvToast.toast(
            "Jumlah data dalam keranjang : " +
              store.getSelectedDataListLocalStorageByCurrentUsername()[0].items
                .length,
            {
              title: "Berhasil update data keranjang",
              autoHideDelay: 2000,
              variant: "info",
              "header-class": "font-weight-bolder",
            }
          );
        }.bind(this),
        250
      );
    },
    cancelUpdateDataCart() {
      utils.scrollIntoDiv("tabel-dinamis-progress-stepper-subject");
      setTimeout(
        function () {
          this.idxSelectedData = -1;
          this.isEditSelectedData2 = false;
          this.hasFinishedLoadEditedSelectedData = false;
        }.bind(this),
        200
      );
    },
    updateParentTempDataCart() {
      let selectedData = this.setSelectedData();
      this.updateTempDataCart([selectedData]);
      this.selectedSubject = null;
    },
    setSelectedData() {
      let selectedDimension = this.optionsDimension.map(
        ({ itemsDimension, ...item }) => item // eslint-disable-line no-unused-vars
      );

      selectedDimension.forEach((item, idx) => {
        item.selectedItemDimension = this.selectedDimension[idx];
        if (item.role.toLowerCase() === "region") {
          item.selectedRegionLevel = this.selectedRegionLevel;
          item.selectedProvince = this.selectedProvince;
          item.selectedDistrict = this.selectedDistrict;
          item.selectedSubdistrict = this.selectedSubdistrict;
        }
      });

      let data = {
        // selectedSubject: this.selectedSubject,
        selectedSubject: this.selectedCategory,
        selectedDataset: this.selectedDataset,
        selectedIndicator: this.selectedIndicator,
        selectedPeriod: this.selectedPeriod,
        selectedDimension: selectedDimension,
      };

      return data;
    },
  },
  components: {
    "dataset-selection": DatasetSelection,
    "dimension-selection": DimensionSelection,
    "indicator-selection": IndicatorSelection,
    "period-selection": PeriodSelection,
    "category-selection": CategorySelection,
    "flying-menu-selection": FlyingMenuSelection,
    "bottom-menu-selection": BottomMenuSelection,
    "data-cart-modal": DataCartModal,
  },
};
</script>

<!-- css section-->
<style lang="scss" scoped>
.tabel-dinamis-progress-stepper-selection-item {
  --circle-size: clamp(1.5rem, 5vw, 3rem);
  --spacing: clamp(0.25rem, 2vw, 0.5rem);
  position: relative;
  display: flex;
  gap: 1rem;
  padding-bottom: 4rem;
  scroll-margin-top: 100px;

  &:before {
    content: "";
    flex: 0 0 var(--circle-size);
    height: var(--circle-size);
    border-radius: 50%;
    background-color: var(--stepColor);
  }

  &:not(:last-child) {
    &:after {
      content: "";
      position: absolute;
      left: 0;
      top: calc(var(--circle-size) + var(--spacing));
      bottom: var(--spacing);
      z-index: 0;
      transform: translateX(calc(var(--circle-size) / 2));
      width: 2px;
      background-color: var(--stepColor);
    }
  }
}
</style>

<!-- author: m.hanif.fahyuananto-->
<!-- version 3.0.0 -->
<!-- created on 19-04-2022 -->
